export enum DocumentSessionTypeEnum {
	NORMAL = 'NORMAL',
	SIGNATURE = 'SIGNATURE',
}
